<!-- eslint-disable no-catch-shadow -->
<!-- eslint-disable no-shadow -->
<!-- eslint-disable no-param-reassign -->
<template>
  <div class="flex-nowrap w-full flex justify-between items-center mb-0">
    <div class="dropdown dropdown-left">
      <div tabindex="0" class="ml-3 btn btn-primary text-sm font-semibold">
        List
        <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
            clip-rule="evenodd"
            fill-rule="evenodd"
          />
        </svg>
      </div>
      <ul tabindex="0" class="p-5 shadow menu dropdown-content bg-base-100 rounded-box w-48">
        <li class="listStyle" @click="$router.push(`/admin/engage?courseId=${courseDetails._id}`), $store.commit('setActiveTab', '/admin/engage')">
          <div class="flex items-center">
            <div class="iconStyle"><engage /></div>
            <span class="">Connect</span>
          </div>
        </li>
        <li class="listStyle" @click="$router.push(`/admin/products/${courseDetails._id}`)">
          <div class="flex items-center">
            <div class="iconStyle">
              <font-awesome-icon class="reaction text-gray-600" size="sm" :icon="['far', 'edit']" />
            </div>
            <span class="">Edit</span>
          </div>
        </li>
        <li class="listStyle" @click="refreshCourse()">
          <div class="flex items-center">
            <div class="iconStyle">
              <Refresh width="16px" height="16px" />
            </div>
            <span class="">Refresh</span>
          </div>
        </li>
        <li class="listStyle" @click="setModalDetails('course', courseDetails._id)">
          <div class="flex items-center">
            <div class="iconStyle">
              <font-awesome-icon
                class="reaction text-gray-600"
                size="sm"
                :icon="['far', 'trash-alt']"
              />
            </div>
            <span class="">Delete</span>
          </div>
        </li>
        <li class="listStyle" @click="clonecourse(courseDetails._id)">
          <div class="flex items-center">
            <div class="iconStyle">
              <font-awesome-icon
                class="reaction text-gray-600"
                size="sm"
                :icon="['fas', 'clone']"
              />
            </div>
            <span class="">Clone</span>
          </div>
        </li>
        <li class="listStyle" @click="exportCSV()">
          <div class="flex items-center">
            <div class="iconStyle">
              <font-awesome-icon
                class="reaction text-gray-600"
                size="sm"
                :icon="['far', 'file-excel']"
              />
            </div>
            <span class="">Export</span>
          </div>
        </li>
        <li class="listStyle" @click="importModal()">
          <div class="flex items-center">
            <div class="iconStyle">
              <font-awesome-icon
                class="reaction text-gray-600"
                size="sm"
                :icon="['fas', 'file-import']"
                @click="importModal()"
                style="margin-left: -2px"
              />
            </div>
            <span class="">Import</span>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="mr-5 font-bold text-gray-600 flex">
      Segment:
      <div v-if="isReminderDone"><clock /></div>
      <span class="text-gray-900  ">{{ courseName }}</span>
    </div> -->
    <!-- buttons list -->
    <!-- <div class="text-sm text-right flex flex-nowrap">
      <div class="tooltip" data-tip="Edit Segment">
        <font-awesome-icon
          class="reaction text-gray-600 "
          size="lg"
          :icon="['far', 'edit']"
          @click="$router.push(`/admin/products/${courseDetails._id}`)"
        />
      </div>
      <div  v-if="courseDetails && courseDetails.isDynamicSegment" class="reaction text-gray-600 ">
        <div class="tooltip" data-tip="Refresh list" @click="refreshCourse()">
          <Refresh width="20px" height="20px" />
        </div>
      </div>
      <div class="tooltip" data-tip="Delete Segment">
        <font-awesome-icon
          class="reaction text-gray-600 "
          size="lg"
          :icon="['far', 'trash-alt']"
          @click="setModalDetails('course', courseDetails._id)"
        />
      </div>
      <div class="tooltip tooltip-top" data-tip="Duplicate Segment">
        <font-awesome-icon
          class="reaction text-gray-600 "
          size="lg"
          :icon="['fas', 'clone']"
          @click="clonecourse(courseDetails._id)"
        />
      </div>
      <div class="tooltip tooltip-top" data-tip="Export CSV">
        <font-awesome-icon
          class="reaction text-gray-600 "
          size="lg"
          :icon="['far', 'file-excel']"
          @click="exportCSV()"
        />
      </div>
      <div class="tooltip tooltip-left" data-tip="Import Members">
        <font-awesome-icon
          class="reaction text-gray-600 "
          size="lg"
          :icon="['fas', 'file-import']"
          @click="importModal()"
        />
      </div>
    </div> -->
    <!-- delete confirmation modal  -->
    <delete-modal
      title="Delete Confirmation"
      message="Are you sure you want to delete this?"
      :callback="deleteConfirmed"
      :openModal="feedPopup"
      :handlePopups="closePopup"
    />
    <course-delete-modal
      title="Delete Confirmation"
      message="Do you want to remove all members also?"
      :callback="deleteSegmentAlso"
      :openModal="openDeleteAllModal"
      :handlePopups="() => (openDeleteAllModal = false)"
    />
  </div>
</template>

<style scoped>
.listStyle {
  margin-top: 5px;
  cursor: pointer;
}
.iconStyle {
  width: 35px;
  display: flex;
  justify-content: left;
  align-items: flex-start;
}
</style>

<script>
import store from '@/store';
import courseAPI from '@/services/course';
import lessonAPI from '@/services/lesson';
import utils from '../../services/utils';
import DeleteModal from '@/components/Common/DeleteModal.vue';
import Refresh from '@/components/icons/refresh.vue';
import userInfo from '@/services/userInfo';
import Engage from '../icons/engage.vue';
import CourseDeleteModal from '../Common/CourseDeleteModal.vue';

export default {
  name: 'SegmentDetailsRow',
  store,
  props: [
    'course',
    'fetchCourseAgain',
    'exportCSV',
    'importModal',
    'fetchStudentList',
    'isReminderDone',
  ],
  components: {
    DeleteModal,
    Refresh,
    Engage,
    CourseDeleteModal,
  },
  data() {
    return {
      courseDetails: this.course,
      userInfo: null,
      userId: '',
      feedPopup: false,
      whatToDelete: '',
      deleteId: null,
      promoPopup: false,
      coursedata: [],
      openDeleteAllModal: false,
    };
  },
  async mounted() {
    await this.$store.dispatch('getMyDetails', {});
    this.userId = this.userInfo?.userId;
    if (this.$route.query.userId) {
      this.userId = this.$route?.query?.userId;
    }
  },
  watch: {
    course(newCourses, oldCourses) {
      if (newCourses !== oldCourses) {
        this.courseDetails = newCourses;
      }
    },
  },
  computed: {
    user() {
      return store.state.user;
    },
    courseName() {
      return this.courseDetails?.title?.length > 30
        ? `${this.courseDetails?.title?.slice(0, 30)}...`
        : this.courseDetails?.title;
    },
  },
  methods: {
    closePopup() {
      this.feedPopup = false;
      this.promoPopup = this.whatToDelete === 'Tweet';
    },
    clonecourse(cid) {
      store.commit('toggleLoading', true);
      const payload = {
        courseId: cid,
      };
      // console.log(payload);
      courseAPI
        .cloneCourse(payload)
        .then(() => {
          this.fetchCourseAgain();
        })
        .catch(error => {
          store.commit('toggleLoading', false);
          console.log({ error });
        });
    },
    setModalDetails(whatToDelete, deleteId) {
      this.whatToDelete = whatToDelete;
      this.deleteId = deleteId;
      this.feedPopup = true;
    },
    async deleteSegmentAlso() {
      try {
        this.openDeleteAllModal = false;
        store.commit('toggleLoading', true);
        // deleting only for segment now
        const payload = {
          courseId: this.courseDetails._id,
          removeSubmissions: true,
        };
        const response = await this.$store.dispatch('deleteCourse', payload);
        await this.$store.dispatch('fetchCoursesListWithDetails', {
          userId: this.userId,
        });
        store.commit('toggleLoading', false);
        utils.setStatusMsg(this, response?.message);
      } catch (error) {
        store.commit('toggleLoading', false);
        utils.setStatusMsg(this, error?.response?.data?.message || 'something went wrong');
      }
    },
    async deleteConfirmed() {
      try {
        store.commit('toggleLoading', true);
        if (this.whatToDelete === 'course') {
          await courseAPI.deleteCourse(this.deleteId);
          this.closePopup();
          this.$store.commit('SET_COURSES_WITH_DETAILS', []);
          await this.$store.dispatch('fetchCoursesListWithDetails', {
            userId: this.userId,
          });
          store.commit('toggleLoading', false);
        } else if (this.whatToDelete === 'Tweet') {
          console.log('delete tweetId >> ', this.deleteId);
          const payload = {
            tweetUrl: this.deleteId,
            courseId: this.coursedata._id,
          };
          await courseAPI.deletePromo(payload);
          utils.setStatusMsg(this, 'Announce Tweet Url Successfully Deleted');
          this.setpromoDetails(this.coursedata);
          this.closePopup();
          store.commit('toggleLoading', false);
        } else {
          await lessonAPI.deleteLesson(this.deleteId).then(() => {
            this.closePopup();
            this.fetchCourseAgain();
          });
          store.commit('toggleLoading', false);
        }
      } catch (error) {
        store.commit('toggleLoading', false);
        // deleting only for segment now
        if (error?.response?.data?.code === 10 && this.courseDetails?.type === 'segment') {
          this.closePopup();
          this.openDeleteAllModal = true;
        } else {
          this.closePopup();
          utils.setStatusMsg(this, error?.response?.data?.message || 'something went wrong');
        }
      }
    },
    async refreshCourse() {
      try {
        store.commit('toggleLoading', true);
        await this.$store.dispatch('refreshCourse', {
          courseId: this.course._id,
        });
        await this.fetchStudentList();
        store.commit('toggleLoading', false);
      } catch (error) {
        store.commit('toggleLoading', false);
        utils.setStatusMsg(this, error?.message || 'Something went wrong');
      }
    },
    async getMyMentions() {
      try {
        store.commit('toggleLoading', true);
        const replyRes = await userInfo.getAllMentions();
        console.log({ replyRes });
        await this.fetchStudentList();
        store.commit('toggleLoading', false);
      } catch (error) {
        console.log('get last reply error ', error);
      }
    },
  },
};
</script>

<!-- eslint-enable no-param-reassign -->
